module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    class: _vm.$style.root
  }, [(Object.keys(_vm.options).length > 0) ? _c('b-dropdown', {
    staticClass: "mt-md-2 edit-campaign",
    attrs: {
      "text": _vm.$t("pos.proposal.edit")
    }
  }, [(_vm.options.changeTarget == true) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.onChangeTarget
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.change-target')))]) : _vm._e(), (_vm.options.upsellPrice == true) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.onUpsellPrice
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.upsell-price')))]) : _vm._e(), (_vm.options.upsellAll == true) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.onUpsellAll
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.upsell-all')))]) : _vm._e()], 1) : _vm._e(), (_vm.options.upsellPrice) ? _c('b-modal', {
    ref: "upsellPrice",
    staticClass: "text-center",
    attrs: {
      "size": "lg",
      "title": _vm.$t("pos.proposal.upsell-price"),
      "ok-disabled": _vm.creating
    },
    on: {
      "ok": function($event) {
        _vm.createNewCampaign(true)
      }
    }
  }, [(_vm.newCampaign) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('package-slider-box', {
    attrs: {
      "campaign": _vm.newCampaign,
      "availablePackages": _vm.availablePackages,
      "selectedPackage": _vm.selectedPackage,
      "goalTypes": _vm.goalTypes,
      "packagesArr": _vm.packagesArr,
      "businessCategory": _vm.businessCategory
    }
  }), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "center-vertically"
  }, [_c('reach-info', {
    attrs: {
      "maxReach": _vm.maxReach,
      "minReach": _vm.selectedPackage.reach.min
    }
  })], 1)]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('svg-reach-chart', {
    attrs: {
      "guaranteedReach": _vm.selectedPackage.reach.min,
      "notReached": _vm.maxReach - _vm.selectedPackage.reach.min
    }
  })], 1)])], 1), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form-input', {
    attrs: {
      "label": _vm.$t("pos.proposal.rebook-campaign")
    }
  }, [_c('correct-datepicker', {
    attrs: {
      "slot": "input",
      "disabled": _vm.disabledDates
    },
    slot: "input",
    model: {
      value: (_vm.newCampaign.start_date),
      callback: function($$v) {
        _vm.newCampaign.start_date = $$v
      },
      expression: "newCampaign.start_date"
    }
  })], 1)], 1)]) : _vm._e()]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c14f6478"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit-campaign/EditCampaign.vue
// module id = 963
// module chunks = 1